import React, { useEffect, useState, useRef } from "react";
import { Element } from "react-scroll";
import "./App.css";
import "aos/dist/aos.css";
import AOS from "aos";

import Header from "./components/Header/Header";
import Formulaire from "./components/Formulaire/Formulaire";
import Footer from "./components/Footer/Footer";
import ReveAquatique from "./Pages/ReveAquatique/ReveAquatique";
import HomePage from "./Pages/MainPage/HomePage";
import Piscines from "./Pages/PiscinesContainer/PiscinesContainer";
import Valeurs from "./Pages/Valeurs/Valeurs";
import Avis from "./Pages/Avis/AvisContainer";
import Burger from "./components/Menu/Burger";
import Menu from "./components/Menu/Menu";
import LegalModal from "./components/Modal/LegalModal";
import ContactButton from "./components/Contact/Contact";

import { MobileProvider } from "./context/MobileContext";
import { MobileContext } from "./context/MobileContext";

// Hook to handle click outside the burger menu
const useOnClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) return;
      handler(event);
    };
    document.addEventListener("mousedown", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
    };
  }, [ref, handler]);
};

function App() {
  useEffect(() => {
    AOS.init(/* { disable: window.innerWidth < 721 } */);
  }, []);

  const [open, setOpen] = useState(false); // state of menu (open/close)
  const node = useRef(); // Référence to handle outside click

  useOnClickOutside(node, () => setOpen(false));

  const [isLegalModalOpen, setLegalModalOpen] = useState(false);

  const handleOpenLegalModal = () => {
    setLegalModalOpen(true);
  };

  const handleCloseLegalModal = () => {
    setLegalModalOpen(false);
  };

  return (
    <MobileProvider>
      {" "}
      {/* MobileProvider */}
      <div className="App">
        {/* MobileConsumer */}
        <MobileContext.Consumer>
          {({ isMobile, isTablet, isLaptop }) => (
            <>
              {!isMobile && !isTablet && !isLaptop && (
                <Element name="destination-sbhm">
                  <Header />
                </Element>
              )}

              {!isMobile && !isTablet && !isLaptop && <ContactButton />}

              {(isMobile || isTablet || isLaptop) && (
                <div ref={node}>
                  <Burger open={open} setOpen={setOpen} />
                  <Menu open={open} setOpen={setOpen} />
                </div>
              )}

              <Element name="destination-main">
                <HomePage />
              </Element>

              <Element name="destination-about">
                <ReveAquatique />
                <Valeurs />
              </Element>

              <Element name="destination-piscines">
                <Piscines />
              </Element>
              <Element name="destination-avis">
                <Avis />
              </Element>

              <LegalModal
                isOpen={isLegalModalOpen}
                onClose={handleCloseLegalModal}
              />

              <Element name="destination-contact">
                <Formulaire />
              </Element>

              <Footer onOpenLegalModal={handleOpenLegalModal} />
            </>
          )}
        </MobileContext.Consumer>
      </div>
    </MobileProvider>
  );
}

export default App;
